import React, { useState } from 'react';

import CryptoJS from 'crypto-js';

const secretKey = 'KPedia%^!#@_katbookView_(*&^_Acce(KP)';

export const encyptedData = (data) => {
    return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
};

export const decryptedData = (data) => {
    const dataconvert = CryptoJS.AES.decrypt(
        data, 
        secretKey
    );
    try {
        if(dataconvert.toString() !== ""){
            return JSON.parse(dataconvert.toString(CryptoJS.enc.Utf8))
        } else {
            return ''
        }
    } catch (error) {
        console.error("Decryption failed or result is not valid JSON");
    }
    
};

